import React from 'react';
import { useShepherdTour } from './useShepherdTour';
import { TOUR_DATA } from './tourData';

const DailyFeedbackTour = ({ autoStart = false, onComplete }) => {
  const { startTour } = useShepherdTour('daily_feedback', TOUR_DATA.daily_feedback.steps, autoStart, onComplete);

  return (
    <>
    {/* <button onClick={startTour} className="btn btn-primary mt-3">
      Start Daily Feedback Tour
    </button> */}
    </>
  );
};

export default DailyFeedbackTour;